import React from 'react';
import { Link } from 'react-router-dom';
import Glyph from './Glyph';
import NewsletterSubscription from './NewsletterSubscription';
import { APP_STORE_URL } from './AppStoreLink';

/**
 * Footer (handoff §9), extended with the newsletter signup (kept working - 
 * it posts to the Cloudflare Worker /newsletter proxy) and the existing
 * legal / changelog routes.
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" id="newsletter">
      <div className="footer-newsletter">
        <div className="footer-newsletter-copy">
          <div className="h3">Stay in the loop</div>
          <p className="body-copy">
            Occasional updates on new scan modes and features. Unsubscribe anytime.
          </p>
        </div>
        <NewsletterSubscription title="" placeholder="Your email" size="compact" />
      </div>

      <div className="hair" />

      <div className="footer-row">
        <div className="footer-brand">
          <Glyph height={29} ink="rgba(244,247,244,.72)" />
          <span className="footer-brand-name">Snapcipe AI</span>
          <span className="footer-brand-year">© {currentYear}</span>
        </div>
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-of-service">Terms</Link>
          <Link to="/cookie-policy">Cookies</Link>
          <Link to="/subprocessors">Subprocessors</Link>
          <Link to="/changelog">Changelog</Link>
          <a href="mailto:support@snapcipe.app">Support</a>
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            App Store
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
